export default {
  LIST_FETCHED: 'NOW_PLAYING_FETCHED',
  LIST_LOAD: 'NOW_PLAYING_LOAD',
  ITEM_DETAIL: 'NOW_PLAYING_DETAIL',
  BUTTON_LOAD: 'NOW_PLAYING_BUTTON_LOAD',
  SUBSCRIBED: 'NOW_PLAYING_SUBSCRIBED',
};
